<div class="widget statistics">
  <p-tabs value="0" class="customTabView" (valueChange)="onTabChange($event)">
    <p-tablist>
      <p-tab value="0">{{ "statistics.global_statistics.title" | translate }}</p-tab>
      <p-tab value="1">{{ "statistics.humidity_statistics.title" | translate }}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        @defer {
          <app-global-statistics></app-global-statistics>
        }
      </p-tabpanel>
      <p-tabpanel value="1">
        @defer (on viewport) {
          <app-humidity-statistics></app-humidity-statistics>
        } @placeholder {
          <div></div>
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
